import { Helmet } from 'react-helmet-async'

import {
  Box, Button, Columns, PageHeader,
} from '@domain-group/suit-theme'

import useTaskList from '@hooks/useTaskList'

import { generateTabBarItems } from '@sections/Admin/packs/Projects/screens/Detail/functions/generateTabBarItems'

import ProjectBurnDownChart from '../ProjectBurnDownChart'
import ProjectOverview from '../ProjectOverview'

interface PageContentProps {
  taskListId: number,
}

const PageContent = (props: PageContentProps) => {
  const { taskListId } = props

  const taskListPayload = useTaskList({ id: taskListId })
  const {
    taskList,
    urls: { taskListsIndexUrl },
  } = taskListPayload

  return (
    <>
      <Helmet>
        <title>Project | Template Manager</title>
      </Helmet>

      <PageHeader
        actionContent={(
          <Button
            // @ts-expect-error TS2322
            as="a"
            buttonStyle="secondaryUtility"
            href={taskListsIndexUrl}
            size="medium"
            width="auto"
          >
            Back
          </Button>
        )}
        activeTabBarItemKey="analytics"
        boxProps={{ height: [112, 105], justifyContent: 'flex-start' }}
        nestedNavigation
        tabBarItems={generateTabBarItems(taskList)}
        title="Analytics"
      />

      <Box paddingX="large" paddingTop={[112, 105]}>
        <Columns boxProps={{ marginTop: 'large' }} flexDirection={['column', 'column', 'row']}>
          <Columns.Main>
            {/*
             // @ts-expect-error TS2322 */}
            <ProjectBurnDownChart taskList={taskList} />
          </Columns.Main>

          <Columns.Sidebar>
            {/*
             // @ts-expect-error TS2322 */}
            <ProjectOverview taskList={taskList} />
          </Columns.Sidebar>
        </Columns>
      </Box>
    </>
  )
}

export default PageContent
